import datetime from "sports4me-web_components/utils/datetime"

export default {
  ...datetime
};
